import { Input, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_FEATURE_NAME_LENGTH } from '@hero/constants';

import * as S from './style';

function CreateRecognitionForm({ formik }) {
  const { t } = useTranslation();

  return (
    <S.Form>
      <S.FormItem>
        <S.ModalSubTitleWrapper>
          <Typography
            as="div"
            variant="body2Bold"
            color="accent-secondary"
            emphasis="default"
            style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}
          >
            {t('whatWouldYouLikeToNameIt')}
            <Typography variant="caption1">{`(${t('helpsYouIdentifyItLater')})`}</Typography>
          </Typography>
        </S.ModalSubTitleWrapper>
        <Input
          name="name"
          variant="outlined"
          value={formik.values.name}
          label={`${t('giftName')}*`}
          onChange={formik.handleChange}
          inputProps={{
            maxLength: MAX_FEATURE_NAME_LENGTH
          }}
          helperText={`${formik.values.name.length}/${MAX_FEATURE_NAME_LENGTH} characters`}
        />
      </S.FormItem>
    </S.Form>
  );
}

export { CreateRecognitionForm };
